import { Box, Flex } from '@chakra-ui/react'
import { GreyGrey50, GreyGrey60, Lato12Bold } from '@sequencehq/design-tokens'
import { timelinePhasesAtom } from '../atoms/timeline.atom'
import { useAtom } from 'jotai'
import {
  BILLING_PERIOD_PILL_OFFSET_FROM_DATE_PX,
  TIMELINE_PHASE_ROW_HEIGHT_PX,
  TIMELINE_DATA_SERIES_Z_INDEX,
  TIMELINE_PHASE_MARKERS_Z_INDEX
} from '../timeline.constants'
import { useTimelineDimensions } from '../hooks/useTimelineDimensions'
import { ArrowPathIcon } from '@heroicons/react/16/solid'

const PhaseMarker = (props: {
  offset: number
}) => {
  return (
    <Box
      position="absolute"
      left={`${props.offset}px`}
      borderLeft={`1px dashed ${GreyGrey50}`}
      height="100%"
      top={0}
      zIndex={TIMELINE_PHASE_MARKERS_Z_INDEX}
    ></Box>
  )
}

const PhaseLabel = (props: {
  offset: number
  name: string
  resetsBilling?: boolean
}) => {
  return (
    <>
      <Flex
        position="absolute"
        top="8px"
        left={`${props.offset + BILLING_PERIOD_PILL_OFFSET_FROM_DATE_PX}px`}
        {...Lato12Bold}
        color={GreyGrey60}
        gap="4px"
      >
        {props.name}
        {props.resetsBilling && (
          <ArrowPathIcon height="16px" width="16px" color={GreyGrey60} />
        )}
      </Flex>
    </>
  )
}

export const ScheduleTimelinePhases = () => {
  const [timelinePhases] = useAtom(timelinePhasesAtom)
  const { timelineWidth } = useTimelineDimensions()

  return (
    <>
      {timelinePhases.map(phase => (
        <PhaseMarker offset={phase.startDate.offset} key={phase.id} />
      ))}
      <Box
        position="relative"
        height={`${TIMELINE_PHASE_ROW_HEIGHT_PX}px`}
        width={`${timelineWidth}px`}
        overflow="hidden"
        data-testid="timeline.phases"
        zIndex={TIMELINE_DATA_SERIES_Z_INDEX}
        pointerEvents="none"
      >
        {timelinePhases.map(phase => (
          <PhaseLabel
            key={phase.id}
            offset={phase.startDate.offset}
            name={phase.name}
            resetsBilling={phase.resetsBilling}
          />
        ))}
      </Box>
    </>
  )
}
